//https://redux.js.org/introduction/why-rtk-is-redux-today#what-does-the-redux-core-do

import { configureStore } from '@reduxjs/toolkit'

import { usersSlice, unitsSlice, userUpdateslice, userInfoSlice, updatePasswordslice } from 'slices/user/user.slice';
import { registrationSlice } from 'slices/user/registration.slice';

import loginSlice from 'slices/user/login.slice';
import { productListSlice, productAddSlice, productUpdateSlice, stockByBarcodeSlice } from 'slices/inventory/product.slice';
import { supplierListSlice, supplierAddSlice, supplierUpdateSlice } from 'slices/supplier/supplier.slice';
import { uomListSlice, uomAddSlice, uomUpdateSlice } from 'slices/other/uom.slice';
import { shopListSlice, shopAddSlice, shopUpdateSlice } from 'slices/other/shop.slice';
import { categoryListSlice, categoryAddSlice, categoryUpdateSlice } from 'slices/other/category.slice';
import { brandListSlice, brandAddSlice, brandUpdateSlice } from 'slices/other/brand.slice';
import { requisitionListSlice, requisitionAddSlice, requisitionUpdateSlice, requisitionItemsSlice, requisitionItemsForWorkOrderSlice } from 'slices/requisition/requisition.slice';
import { workOrderListByShopSlice, workOrderAddSlice, workOrderUpdateSlice, deleteWorkOrderSlice, workOrderItemsSlice, workOrderItemsForChalanSlice, workOrderDetailSlice } from 'slices/workorder/workOrder.slice';
import { chalanAddSlice, chalanUpdateSlice, deleteChalanSlice, chalanListByShopSlice, chalanItemsSlice, chalanDetailSlice } from 'slices/chalan/chalan.slice';
import { stockUpdateSlice, stockListSlice, stockListForSaleSlice } from 'slices/stock/stock.slice';
import { saleAddSlice, saleUpdateSlice } from 'slices/sale/sale.slice';
import { returnAddSlice, returnListSlice, returnUpdateSlice, returnItemsSlice } from 'slices/return/return.slice';
import { invoiceListSlice, saleDetailSlice } from 'slices/saleDetails/saleDetails.slice';
import { reportListSlice } from 'slices/report/report.slice';
import categorySlice from 'slices/dropdown/category.slice';
import requisitionTypeSlice from 'slices/dropdown/requisitionType.slice';
import userTypeSlice from 'slices/dropdown/userType.slice';
import supplierNameSlice from 'slices/dropdown/supplierName.slice';
import productNameSlice from 'slices/dropdown/productName.slice';
import requisitionNameSlice from 'slices/dropdown/requisitionName.slice';
import workOrderNameSlice from 'slices/dropdown/workOrderName.slice';
import chalanNamesSlice from 'slices/dropdown/chalan.slice';

import { dashboardSlice, } from 'slices/dashboard/dashboard.slice';


const reducer = {
  users: usersSlice.reducer,
  userInfo: userInfoSlice.reducer,
  units: unitsSlice.reducer,
  login: loginSlice,
  registration: registrationSlice.reducer,
  userUpdate: userUpdateslice.reducer,
  updatePassword: updatePasswordslice.reducer,

  productList: productListSlice.reducer,
  productAdd: productAddSlice.reducer,
  productUpdate: productUpdateSlice.reducer,
  stockByBarcode: stockByBarcodeSlice.reducer,

  supplierList: supplierListSlice.reducer,
  supplierAdd: supplierAddSlice.reducer,
  supplierUpdate: supplierUpdateSlice.reducer,

  requisitionList: requisitionListSlice.reducer,
  requisitionItemsForWorkOrderList: requisitionItemsForWorkOrderSlice.reducer,
  requisitionAdd: requisitionAddSlice.reducer,
  requisitionUpdate: requisitionUpdateSlice.reducer,
  requisitionItems: requisitionItemsSlice.reducer,

  uomList: uomListSlice.reducer,
  uomAdd: uomAddSlice.reducer,
  uomUpdate: uomUpdateSlice.reducer,

  shopList: shopListSlice.reducer,
  shopAdd: shopAddSlice.reducer,
  shopUpdate: shopUpdateSlice.reducer,

  categoryList: categoryListSlice.reducer,
  categoryAdd: categoryAddSlice.reducer,
  categoryUpdate: categoryUpdateSlice.reducer,

  brandList: brandListSlice.reducer,
  brandAdd: brandAddSlice.reducer,
  brandUpdate: brandUpdateSlice.reducer,

  workOrderByShopList: workOrderListByShopSlice.reducer,
  workOrderAdd: workOrderAddSlice.reducer,
  workOrderUpdate: workOrderUpdateSlice.reducer,
  workOrderItems: workOrderItemsSlice.reducer,
  deleteWorkOrder: deleteWorkOrderSlice.reducer,
  workOrderItemsForChalanList: workOrderItemsForChalanSlice.reducer,
  workOrderDetail: workOrderDetailSlice.reducer,

  chalanAdd: chalanAddSlice.reducer,
  chalanByShopList: chalanListByShopSlice.reducer,
  chalanItems: chalanItemsSlice.reducer,
  chalanUpdate: chalanUpdateSlice.reducer,
  deleteChalan: deleteChalanSlice.reducer,
  chalanDetail: chalanDetailSlice.reducer,

  stockUpdate: stockUpdateSlice.reducer,
  stockList: stockListSlice.reducer,
  stockListForSale: stockListForSaleSlice.reducer,

  saleAdd: saleAddSlice.reducer,
  saleUpdate: saleUpdateSlice.reducer,

  invoiceList: invoiceListSlice.reducer,
  saleDetail: saleDetailSlice.reducer,

  returnAdd: returnAddSlice.reducer,
  returnList: returnListSlice.reducer,
  returnUpdate: returnUpdateSlice.reducer,
  returnItems: returnItemsSlice.reducer,

  reportList: reportListSlice.reducer,

  categories: categorySlice,
  requisitionTypes: requisitionTypeSlice,
  supplierNames: supplierNameSlice,
  productNames: productNameSlice,
  requisitionNames: requisitionNameSlice,
  workOrderNames: workOrderNameSlice,
  chalanNames: chalanNamesSlice,
  userType: userTypeSlice,


  dashboard: dashboardSlice.reducer,

}


export default configureStore({
  reducer: reducer,
  devTools: true,
})